import React, { ReactElement, useState } from 'react';
import ReactDOM from 'react-dom';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { Button } from '../Input/Button/Button';
import closeImage from '../../assets/close.png';
import styles from './zoom.module.scss';

interface ZoomProps {
  children: ReactElement;
}

export const Zoom: React.FC<ZoomProps> = ({ children }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const handleZoomChange = (shouldZoom: boolean) => setIsZoomed(shouldZoom);

  function renderCloseButton() {
    return ReactDOM.createPortal(
      <Button
        title="Unzoom image"
        variant="minimal"
        onClick={() => setIsZoomed(false)}
        className={styles.closeButton}
      >
        <img src={closeImage} alt="Unzoom" width="36" />
      </Button>,
      document.body,
    );
  }

  return (
    <>
      {isZoomed && renderCloseButton()}
      <ControlledZoom
        isZoomed={isZoomed}
        onZoomChange={handleZoomChange}
        zoomMargin={100}
        overlayBgColorEnd="rgba(200, 200, 200, 0.8)"
        transitionDuration={200}
        zoomZindex={1000}
      >
        {children}
      </ControlledZoom>
    </>
  );
};
